<template>
  <v-dialog
    :value="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    :fullscreen="true"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular pl-5 pr-3 py-3"
      >
        <div v-if="dialogWait">
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-2"
            medium
            >mdi-timer-sand</v-icon
          >
          {{ $t("userNewOrderPleaseWaitTitle") }}
        </div>
        <div v-else>
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-2"
            medium
            >mdi-square-edit-outline</v-icon
          >
          {{ $t("userNewPhotoGiftOrderCropTitle") }}
        </div>
        <v-spacer></v-spacer>
        <v-btn
          text
          medium
          @click="active = false"
          style="min-width: 0; width: 20px"
        >
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-progress-linear
        v-show="dialogWait"
        color="primary"
        height="10"
        indeterminate
      ></v-progress-linear>
      <v-card-text
        class="pa-0 py-1 ma-0 mt-1 d-flex align-center"
        style="overflow: hidden"
      >
        <v-spacer></v-spacer>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="preFitInImage()"
        >
          <v-icon>mdi-fit-to-page-outline</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="rotateImage(90)"
        >
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="zoomImage(0.05)"
        >
          <v-icon>mdi-magnify-plus</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="zoomImage(-0.05)"
        >
          <v-icon>mdi-magnify-minus</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="flipXImage()"
        >
          <v-icon>mdi-flip-horizontal</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="flipYImage()"
        >
          <v-icon>mdi-flip-vertical</v-icon>
        </v-btn>
        <v-btn
          medium
          text
          outlined
          color="secondary"
          class="mr-1"
          style="min-width: 0; width: 32px"
          @click="resetImage()"
        >
          <v-icon>mdi-circle-off-outline</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-text>
      <v-card-text class="pa-0 my-1 d-flex" style="width: 100%">
        <!-- key je določen zato, ker ponovno renderira cropper ob spremembi viewMode-a -->
        <v-spacer></v-spacer>
        <vueCropper
          :key="viewMode"
          style="overflow: hidden"
          ref="cropper2"
          :guides="false"
          :modal="false"
          :checkOrientation="false"
          :toggleDragModeOnDblclick="false"
          :autoCropArea="1.02"
          :rotatable="true"
          :scalable="true"
          :viewMode="viewMode"
          dragMode="move"
          :ready="imReady"
          :highlight="true"
          :containerStyle="{
            'background-color': 'white',
          }"
        ></vueCropper>
        <v-spacer></v-spacer>
      </v-card-text>
      <v-progress-linear
        v-show="dialogWait"
        color="primary"
        height="10"
        indeterminate
      ></v-progress-linear>
      <v-card-actions
        class="pa-2 ma-0"
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        style="height: 80px"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="active = false" class="mx-2">{{
          $t("addEditFormCancelButton")
        }}</v-btn>
        <v-btn
          v-if="showButton"
          color="primary elevation-0"
          class="mx-2"
          dark
          @click="cropFinal"
        >
          <v-icon class="mr-1">mdi-crop</v-icon>
          {{ $t("lmBtnCrop") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// VueCropper local import
import "cropperjs/dist/cropper.css";
import VueCropper from "vue-cropperjs";
import * as c from "@/constants";

export default {
  name: "dialog-vue-cropper-image",
  data() {
    return {
      showButton: true, // za reset click.once
      dialogWait: false,
      scaleX: 1,
      scaleY: 1,
      viewMode: 1,
    };
  },
  components: {
    VueCropper,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    cropperItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    active: {
      get() {
        if (this.value) {
          //this.checkQuality();
          this.start();
          this.replaceImage();
        }
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    imReady() {
      this.dialogWait = false;
    },
    start() {
      this.viewMode = 1;
    },
    replaceImage() {
      this.showButton = true;
      this.dialogWait = true;
      if (this.$refs.cropper2 != undefined) {
        this.$refs.cropper2.destroy();
      }
      // cropper update z novo sliko
      let that = this;
      setTimeout(function () {
        that.$refs.cropper2.replace(that.cropperItem.src);
        that.$refs.cropper2.setAspectRatio(that.cropperItem.aspectRatioStore);
      }, 0);
    },
    cropFinal() {
      this.showButton = false;

      this.$emit("croppedImage", {
        src: this.$refs.cropper2
          .getCroppedCanvas({
            width: Number(this.cropperItem.sWidth),
            height: Number(this.cropperItem.sHeight),
            imageSmoothingEnabled: false,
            imageSmoothingQuality: "high",
            fillColor: "#ffffff",
          })
          .toDataURL("image/jpeg", c.G_FILE_COMPRESSION),
        srcThumb: this.$refs.cropper2
          .getCroppedCanvas({
            width: 150 * this.cropperItem.aspectRatio,
            height: 150,
            imageSmoothingEnabled: false,
            imageSmoothingQuality: "high",
            fillColor: "#ffffff",
          })
          .toDataURL("image/jpeg", c.G_FILE_COMPRESSION),
      });

      this.active = false;
    },
    /* VUE CROPPER BUTTON HANDLERS */
    preFitInImage() {
      if (this.viewMode == 0) {
        this.viewMode = 1;
      } else this.viewMode = 0;

      this.replaceImage();
    },
    rotateImage(degrees) {
      this.$refs.cropper2.rotate(degrees);
    },
    flipXImage() {
      this.scaleX = this.scaleX == 1 ? -1 : 1;
      this.$refs.cropper2.scaleX(this.scaleX);
    },
    flipYImage() {
      this.scaleY = this.scaleY == 1 ? -1 : 1;
      this.$refs.cropper2.scaleY(this.scaleY);
    },
    zoomImage(percent) {
      this.$refs.cropper2.relativeZoom(percent);
    },
    resetImage() {
      this.$refs.cropper2.reset();
      //this.$refs.cropper2.relativeZoom(0.02);
      this.scaleX = 1;
      this.scaleY = 1;
    },
  },
};
</script>

<style scoped>
</style>